__turbopack_context__.v({
  "tabContent": "WhoTabContent-module__bm03zG__tabContent",
});
